import React from 'react';
import { PrimaryButton, SecondaryOutlineButton } from 'Core/components/Button';

export default function Confirm({
  title,
  description,
  confirmButtonLabel,
  cancelButtonLabel,
  onConfirm,
  onCancel,
}) {
  return (
    <div className="bg-white border border-solid border-gray-300 rounded p-4 relative mb-6 w-full max-w-xl shadow-lg">
      <div className="border-b border-solid border-gray-300 font-bold text-xl pb-2 mb-2">
        {title}
      </div>
      <div style={{ minHeight: '80px' }}>{description}</div>
      <div className="flex justify-end">
        <SecondaryOutlineButton className={`!px-8 !mr-2`} onClick={onCancel} data-testid="cancel">
          {cancelButtonLabel}
        </SecondaryOutlineButton>
        <PrimaryButton className={`!px-8`} onClick={onConfirm} data-testid="confirm">
          {confirmButtonLabel}
        </PrimaryButton>
      </div>
    </div>
  );
}
